import { APRType } from '../../../context';

export const SUBHEADINGS: Record<APRType, string> = {
  BUYNOW_PAYLATER: 'Deferred Payment',
  INTEREST_BEARING: 'Representative APR',
  INTEREST_FREE: 'Borrow Interest Free',
};

export const POINTS: Record<APRType, string[]> = {
  BUYNOW_PAYLATER: [
    'Pay nothing, some, or all of your loan at 0% within the first {{deferredDurations}} months',
    'Followed by {{apr}} APR over {{fullDurations}}, from {{minimumMonthly}}/month',
  ],
  INTEREST_BEARING: [
    'Spread payments over up to {{maxDuration}} months',
    'Pay off your loan early to reduce interest fees',
  ],
  INTEREST_FREE: [
    'Spread payments over up to {{maxDuration}} months',
    'No interest charged on your loan',
    'Best choice if your credit score is high',
  ],
};
